import { render, staticRenderFns } from "./SliderPlaceholder.vue?vue&type=template&id=08d5b608"
import script from "./SliderPlaceholder.vue?vue&type=script&lang=js"
export * from "./SliderPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports